import {ValueFormatterParams} from "ag-grid-community";
import React from "react";

export const ProductLinkComponent = ({value}: { value: string }) => <a href={value.split(', ')[1]} target="_blank" rel="noreferrer" style={{color: "yellow"}}>{value.split(', ')[0]}</a>;
export const DocumentLinkComponent = ({value}: { value: string | undefined }) => <a href={value} target="_blank" rel="noreferrer" style={{color: "inherit"}}>{value?.split('&')[1]?.split('=')[1] ?? 'MISSING'}</a>;
export const cellFormatter = (p: ValueFormatterParams) => p.value?.toString() ?? "MISSING";
